import React from 'react';
import './App.css';

function App() {
  return (
    <div className="container">
      <header className="App-header">
        <h1>SOI Reports Archive</h1>
        <div className="alert alert-warning">
          Note: current SOI reports may be found using the EvaluationKit dashboard at <b>https://ua.evaluationkit.com/</b>.{' '}
          This site is for viewing archived reports only.
        </div>
      </header>
      <Form />
    </div>
  );
}

function Form() {
  const [terms, setTerms] = React.useState([])
  const [entities, setEntities] = React.useState([])

  const [selections, setSelections] = React.useState({term:null,entity:null})

  React.useEffect(() => {
    fetch(`${window.api_endpoint}/terms`).then(d => d.json()).then(data => setTerms(data.terms))
  }, [])

  React.useEffect(() => {
    fetch(`${window.api_endpoint}/entities`).then(d => d.json()).then(data => setEntities(data.entities))
  }, [])

  const setTerm = React.useCallback(term => setSelections({...selections, term}), [selections])
  const setEntity = React.useCallback(entity => setSelections({...selections, entity}), [selections])

  if (!terms.length || !entities.length) return <div>loading...</div>

  return (
    <div>
      <div className="form-group">
        <label htmlFor="term">Term: </label>
        <select 
          className="form-control"
          value={selections.term ? selections.term.code : '0'}
          name="term" onChange={({target}) => setTerm(target.value)}
        >
          <option value="0">select a term</option>
          {terms.map(t => (
            <option key={t.code} value={t.code}>{t.name}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="entity">Entity: </label>
        <select 
          className="form-control"
          value={selections.entity ? selections.entity.code : '0'}
          name="entity" onChange={({target}) => setEntity(target.value)}
        >
          <option value="0">select a unit</option>
          {entities.filter(t => !!t.code).map(t => (
            <option key={t.code} value={t.code}>{t.kind}: {t.code}</option>
          ))}
        </select>
      </div>

      {(selections.term && selections.entity) &&
        <Results 
          term={terms.find(t => t.code==selections.term)}
          entity={entities.find(e => e.code==selections.entity)}
        />
      }
    </div>
  )
}

function Results({term, entity}) {
  const [results, setResults] = React.useState(null)
  React.useEffect(() => {
    setResults(null)
    fetch(`${window.api_endpoint}/reports/${term.code}/${entity.kind}/${entity.code}`).then(r => r.json()).then(d => setResults(d))
  }, [term, entity])

  if (!results) return <div>loading...</div>

  return (
    <div>
      {results.agg.length==0 && results.class.length==0 && 
        <div>No reports found for this search.</div>
      }
      {results.agg.length>0 && (
        <div>
          <h2>Aggregate Reports</h2>
          <ul>
            {results.agg.map(c => (
              <li key={c.REPORT_ID}>
                <a target="_blank" href={`https://oiratemp.ua.edu/site/SOI/fetchreport/${c.REPORT_ID}`}>PDF</a> -{' '}
                {c.REPORT_TITLE} 
              </li>
            ))}
          </ul>
        </div>
      )}
      {results.class.length>0 && (
        <div>
          <h2>Class Reports</h2>
          <ul>
            {results.class.map(c => (
              <li key={c.REPORT_ID}>
                <a target="_blank" href={`https://oiratemp.ua.edu/site/SOI/fetchreport/${c.REPORT_ID}`}>PDF</a> -{' '}
                {c.REPORT_TITLE} 
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default App;
